// extracted by mini-css-extract-plugin
export var cardItem = "content-module--card-item--2a0OQ";
export var cardLayout = "content-module--card-layout--Ycy10";
export var contentLayout = "content-module--content-layout--2UWD+";
export var description = "content-module--description--lJuyw";